<script>
export default {
  name: 'UpgradeModal',

  props: {
    show: {
      type: Boolean,
      required: true
    }
  },

  emits: ['upgrade', 'cancel', 'backup'],

  watch: {
    show(val) {
      if (val) {
        this.$nextTick(() => this.$refs.dialog.showModal());
      } else {
        this.$refs.dialog.close();
      }
    }
  }
}
</script>
<template>
  <dialog ref="dialog" class="modal">
    <div class="modal-box">
      <h3 class="text-lg font-bold">Configuration update required</h3>
      <p class="py-4">
        This configuration needs to be updated to work with the current editor.
        We suggest you back up your settings before the update.
      </p>
      <div class="modal-action">
        <button type="button" class="btn btn-ghost mr-auto" @click="$emit('backup')">Backup</button>
        <form method="dialog" class="flex gap-2">
          <button class="btn btn-ghost" @click="$emit('cancel')">Cancel</button>
          <button class="btn btn-primary" @click="$emit('upgrade')">Upgrade</button>
        </form>
      </div>
    </div>
    <form method="dialog" class="modal-backdrop">
      <button @click="$emit('cancel')">close</button>
    </form>
  </dialog>
</template>
